import React from "react";

function OfflineIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.875 1.125L1.125 10.875M1.125 1.125L10.875 10.875" stroke="#667085" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default OfflineIcon;
